import React from "react";
import { Link } from "react-router-dom";
import { WavyDivider } from "./WavyDivider";

export const CTAStrip = ({ topColor = "#FFFFFF" }) => (
  <section data-testid="cta-strip">
    <WavyDivider fromColor={topColor} toColor="#DDE2F7" />
    <div className="bg-[#DDE2F7] py-14 text-center relative overflow-hidden">
      <div className="absolute inset-0 dot-pattern opacity-40" aria-hidden="true" />
      <h3 className="relative text-2xl md:text-3xl font-bold text-kid-navy mb-6">
        Give your child the best start in life!
      </h3>
      <Link to="/contact" className="relative btn-lilac text-lg" data-testid="cta-strip-enquire">
        Contact Us
      </Link>
    </div>
    <WavyDivider fromColor="#DDE2F7" toColor="#EEF0FB" flip />
  </section>
);
